import React, { useState, useEffect, useContext } from 'react'
import Style from './index.module.css'
import instance from "../../instance/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { UserContext } from '../../Contexts/UserContext';
import authInstance from '../../instance/AuthInstance';
import { toast } from 'react-toastify';
import Select from "react-select";
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdModeEditOutline } from 'react-icons/md';
import OtpCard from '../Custom/OtpCard/OtpCard';
import InputForm from '../Custom/InputForm/InputForm';
import { STATES_DISTRICTS_DATA } from './../../utilities/statesDistrictsData';

const UpdateProfileForm = () => {

    const navigate = useNavigate();

    const loggedInUser = useContext(UserContext);
    const { User, SetUser } = loggedInUser

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            padding: '0 1rem',
            fontSize: '14px',
            border: '1px solid #ebebeb',
            borderRadius: '4px',
            boxShadow: state.isFocused ? 'none' : null,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            margin: 0,

            '&:hover': {
                boxShadow: 'none',
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: 'black',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#ccc' : provided.backgroundColor,
            color: state.isSelected ? 'white' : provided.color,
            fontSize: '14px',

        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            borderLeft: 'none',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
    };

    // State variables
    const [registrationDate] = useState(new Date());
    const [minDOB] = useState(() => {
        const minDOBDate = new Date(registrationDate);
        minDOBDate.setFullYear(minDOBDate.getFullYear() - 90);
        return minDOBDate;
    });
    const [maxDOB] = useState(() => {
        const maxDOBDate = new Date(registrationDate);
        maxDOBDate.setFullYear(maxDOBDate.getFullYear() - 18);
        return maxDOBDate;
    });

    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState(false);

    const [IsEmailVerified, SetIsEmailVerified] = useState(false);
    const [IsPhoneVerified, SetIsPhoneVerified] = useState(false);
    const [IsEmailEditing, SetIsEmailEditing] = useState(false);
    const [IsPhoneEditing, SetIsPhoneEditing] = useState(false);

    const [Checking, SetChecking] = useState(false);

    const [otpDetails, setOtpDetails] = useState("");

    const [Error, SetError] = useState({});
    const [CurrentProfileImage, SetCurrentProfileImage] = useState("")
    const [CurrentProfile, SetCurrentProfile] = useState({
        _id: User._id,
        fullname: "",
        surname: "",
        dob: "",
        pseudoName: "",
        address: {
            streetName: "",
            houseName: "",
            locality: "",
            region: "",
            district: "",
            state: "",
        },
        email: "",
        phoneNumber: "",
        emailPreference: ""
    });

    const [UpdateProfile, SetUpdateProfile] = useState({
        dob: "",
        email: "",
        fullname: "",
        phoneNumber: "",
        surname: "",
        pseudoName: "",
        address: {
            streetName: "",
            houseName: "",
            locality: "",
            region: "",
            district: "",
            state: "",
        },
        _id: User._id,
        emailPreference: ""
    });

    const [File, SetFile] = useState({
        File: "",
        FileUrl: "",
        Caption: ""
    });

    // State for location selection
    const [selectedStateName, setSelectedStateName] = useState("");
    const [selectedDistrictName, setSelectedDistrictName] = useState("");

    // Create state options from STATES_DISTRICTS_DATA
    const StateOptions = STATES_DISTRICTS_DATA.states.map((stateObj) => ({
        value: stateObj.state,
        label: stateObj.state
    }));

    // Get districts for selected state
    const getDistrictsForState = (stateName) => {
        const stateObj = STATES_DISTRICTS_DATA.states.find(s => s.state === stateName);
        return stateObj ? stateObj.districts : [];
    };

    // Create district options based on selected state
    const DistrictOptions = selectedStateName 
        ? getDistrictsForState(selectedStateName).map((district) => ({
            value: district,
            label: district
          }))
        : [];

    const options = [
        { value: 'India', label: 'India' },
    ];

    // Load user data
    useEffect(() => {
        try {
            instance.get(`/api/user/profile/get_profile/${User._id}`).then((result) => {
                SetUpdateProfile(result.data);
                SetCurrentProfile(result.data);
                SetCurrentProfileImage(result.data?.profilePicture?.url);
                
                // Set selected state and district from loaded profile
                if (result.data?.address?.state) {
                    setSelectedStateName(result.data.address.state);
                }
                if (result.data?.address?.district) {
                    setSelectedDistrictName(result.data.address.district);
                }
            }).catch((err) => {
                console.log(err);
            })
        } catch (error) {
            console.log(error);
        }
    }, [User]);

    const DefaultImage = "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"

    const uploadFile = (e) => {
        SetFile({
            ...File, FileUrl: URL.createObjectURL(e.target.files[0]),
            File: e.target.files[0]
        });
    }

    // Validation
    const validateForm = () => {
        let newErrors = {};

        if (UpdateProfile.fullname === '') {
            newErrors.fullname = 'Fullname is required';
        }

        if (UpdateProfile.surname === '') {
            newErrors.surname = 'Surname is required';
        }

        if (UpdateProfile.pseudoName === '') {
            newErrors.pseudonym = 'Pseudonym is required';
        }

        if (UpdateProfile.address.houseName === '') {
            newErrors.houseName = 'House Name is required';
        }

        if (UpdateProfile.address.streetName === '') {
            newErrors.streetName = 'Street Name is required';
        }

        if (UpdateProfile.address.state === '') {
            newErrors.state = 'State is required';
        }

        if (UpdateProfile.address.district === '') {
            newErrors.district = 'District is required';
        }

        if (UpdateProfile.address.region === '') {
            newErrors.region = 'Region is required';
        }

        SetError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handler for validating date of birth
    const handleDOBChange = (event) => {
        const inputDate = new Date(event.target.value);
        if (inputDate > maxDOB) {
            SetError({ ...Error, dob: "You must be at least 18 years old." });
        } else if (inputDate < minDOB) {
            SetError({ ...Error, dob: "You cannot be more than 90 years old." });
        } else {
            SetError({ ...Error, dob: "" });
        }
        SetUpdateProfile({ ...UpdateProfile, dob: event.target.value })
        SetError({ ...Error, dob: "" });
    };

    const email_validation = (email) => {
        if (/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/.test(email)) {
            SetError({ ...Error, email: "" });
            return true;
        } else {
            SetError({ ...Error, email: "Invalid email" });
            return false;
        }
    };

    const phone_validation = (phoneNumber) => {
        if (phoneNumber !== "") {
            if (phoneNumber.toString().length < 10) {
                SetError({ ...Error, phoneNumber: "Phonenumber must have 10 digits" });
            } else {
                SetError({ ...Error, phoneNumber: "" });
                return true;
            }
        } else {
            SetError({ ...Error, phoneNumber: "This field cannot be empty" });
            return false;
        }
    };

    // Handle Pseudonym checking
    const HandleChecking = (Pseudo) => {
        SetChecking(true);
        try {
            authInstance.post('/api/user/profile/check_pseudoname', { pseudoNameCheck: Pseudo }).then((response) => {
                SetUpdateProfile({ ...UpdateProfile, pseudoName: Pseudo });
                SetChecking(false);
                SetError({ ...Error, pseudonym: "" });
            }).catch((err) => {
                SetChecking(false);
                SetError({ ...Error, pseudonym: "These name is already taken" });
            })
        } catch (error) {
            console.log(error);
        }
    }

    // Handle submit
    const HandleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            let data = new FormData()
            if (File.File === "") {
                if (CurrentProfileImage !== "") {
                    data.append("file", DefaultImage)
                } else {
                    data.append("file", DefaultImage)
                }
            } else {
                data.append("file", File.File)
            }

            const objectData = JSON.stringify(UpdateProfile);
            data.append('userData', objectData);

            authInstance.put('/api/user/profile/update_profile', data).then((Response) => {
                toast.success("profile updated")
                navigate('/profile')
            }).catch((err) => {
                console.log(err);
                toast.error("Something Went Wrong")
            })

            SetError({});
        } else {
            console.log('Form validation failed');
        }
    };

    // Email & phone otp verify
    const handleVerifyEmail = (e) => {
        e.preventDefault();
        authInstance.post("/api/user/profile/update_email", { 
            updatingEmail: UpdateProfile.email, 
            currentEmail: CurrentProfile.email, 
            userId: User._id 
        }).then((response) => {
            setLoading(false);
            setOtp(true);
        }).catch((Error) => {
            setLoading(false);
            toast.error(Error.response.data.message);
        });
    }

    const handleVerifyPhoneNumber = (e) => {
        e.preventDefault();
        authInstance.post("/api/user/profile/update_phone", { 
            phonenumber: UpdateProfile.phoneNumber, 
            userId: User._id 
        }).then((response) => {
            setLoading(false);
            setOtp(true);
        }).catch((Error) => {
            setLoading(false);
            toast.error(Error.response.data.message);
        });
    }

    // OTP Verify Handler
    const otpVerifyHandle = (e) => {
        e.preventDefault();
        SetError({ ...Error, otp: "" });
        if (e.target.value === "") {
            SetError({ ...Error, otp: "enter the otp" });
        } else {
            setLoading(true);
            IsPhoneEditing
                ? authInstance.put("/api/user/profile/verify_phone", { 
                    otp: otpDetails, 
                    phoneNumber: UpdateProfile.phoneNumber, 
                    userId: User._id 
                }).then((response) => {
                    setLoading(false);
                    setOtp(false)
                    SetIsPhoneVerified(true)
                    SetIsPhoneEditing(false)
                    toast.success("phone number verified")
                    setOtpDetails("")
                }).catch((error) => {
                    setLoading(false);
                    toast.error("failed phone number verification")
                    setOtp(false)
                })
                : authInstance.put("/api/user/profile/verify_email", { 
                    otp: otpDetails, 
                    updatingEmail: UpdateProfile.email, 
                    currentEmail: CurrentProfile.email, 
                    userId: User._id 
                }).then((response) => {
                    setLoading(false);
                    setOtp(false)
                    SetIsEmailVerified(true)
                    SetIsEmailEditing(false)
                    toast.success("email verified")
                    setOtpDetails("")
                }).catch((error) => {
                    setLoading(false);
                    toast.error("failed email verification")
                    setOtp(false)
                });
        }
    };

    // Delete User Profile
    const handleDeleteUser = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#046BD2',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                authInstance.delete(`/api/user/profile/delete_account/${User._id}`).then((response) => {
                    toast.success("user deleted")
                    localStorage.removeItem('logged');
                    localStorage.removeItem('token');
                    SetUser("");
                    navigate('/registration_login')
                }).catch((error) => {
                    console.log(error);
                    toast.error("error deleting user")
                })
            }
        })
    }

    return (
        <div className={Style.content_wrapper}>
            <div className={Style.container}>
                {otp ? (
                    <OtpCard
                        otp={otp}
                        setOtp={setOtp}
                        otpDetails={otpDetails}
                        setOtpDetails={setOtpDetails}
                        loading={loading}
                        otpVerifyHandle={otpVerifyHandle}
                        Error={Error}
                    />
                ) : (
                    <div className={Style.main_row}>
                        <form action="" onSubmit={(e) => HandleSubmit(e)}>
                            <div className={Style.left}>
                                <div className={Style.row}>
                                    <div className={Style.left_col}>
                                        <div className={Style.Image_info}>
                                            <img
                                                src={
                                                    File.FileUrl
                                                        ? File.FileUrl
                                                        : CurrentProfileImage || "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                                                }
                                                alt=""
                                            />
                                            <div className={Style.formImage}>
                                                <label htmlFor="file">
                                                    <i><MdModeEditOutline /></i>
                                                </label>
                                                <input
                                                    type="file"
                                                    id="file"
                                                    onChange={uploadFile}
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={Style.row} >
                                    <div className={Style.items}>
                                        <div className={Style.item} onClick={() => navigate(`/changepassword/${User._id}`)}>
                                            <span> <i> <MdModeEditOutline /> </i> Change Account Password </span>
                                        </div>
                                        <div className={Style.item}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={UpdateProfile.Notification}
                                                    onChange={(e) =>
                                                        SetUpdateProfile((prev) => ({
                                                            ...prev,
                                                            Notification: e.target.checked,
                                                        }))
                                                    }
                                                />
                                                <p style={{ fontSize: "12px", margin: 0 }}>
                                                    Allow Permission to Advertisement Emails
                                                </p>
                                            </div>
                                        </div>
                                        <div className={Style.item} onClick={() => { handleDeleteUser() }}>
                                            <span> <i> <RiDeleteBin6Line className={Style.del_icon} /> </i> Delete Account </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={Style.right}>
                                <div className={Style.title}>
                                    <h2>Basic Information</h2>
                                </div>
                                <div className={Style.notificationDiv}>
                                    <p>All your private informations are for KYC purpose (Know Your Customer)
                                        and are safe with us. We won't share or sell it to third party!</p>
                                </div>
                                <div className={Style.form_wrapper}>
                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>First Name <span>*</span></label>
                                            <InputForm
                                                type="text"
                                                placeholder='First Name'
                                                id="Fullname"
                                                name="fullname"
                                                value={UpdateProfile.fullname}
                                                onChange={(e) => { SetUpdateProfile({ ...UpdateProfile, fullname: e.target.value }) }}
                                            />
                                            <p className={Style.error}>{Error.fullname}</p>
                                        </div>
                                        <div className={Style.col}>
                                            <label>Last Name <span>*</span></label>
                                            <InputForm
                                                type="text"
                                                placeholder='Last Name'
                                                id="Lastname"
                                                name="lastname"
                                                value={UpdateProfile.surname}
                                                onChange={(e) => { SetUpdateProfile({ ...UpdateProfile, surname: e.target.value }) }}
                                            />
                                            <p className={Style.error}>{Error.surname}</p>
                                        </div>
                                    </div>
                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>Pseudonym <span>*</span></label>
                                            <div className={Style.border_col}>
                                                <InputForm
                                                    type="text"
                                                    placeholder='Pseudonym'
                                                    id="Pseudonym"
                                                    name="Pseudonym"
                                                    value={UpdateProfile.pseudoName}
                                                    onChange={(e) => {
                                                        SetUpdateProfile({ ...UpdateProfile, pseudoName: e.target.value });
                                                        HandleChecking(e.target.value);
                                                    }}
                                                    customClass={Style.borderless}
                                                />
                                                {Checking && (
                                                    <div className={Style.check}>
                                                        <span>Checking ...</span>
                                                    </div>
                                                )}
                                            </div>
                                            <p className={Style.error}>{Error.pseudonym}</p>
                                        </div>
                                    </div>
                                    <div className={Style.row}>
                                        <div className={Style.col}>
                                            <label>Date of Birth <span>*</span></label>
                                            <input
                                                type="date"
                                                placeholder='Date Of Birth'
                                                id="Date Of Birth"
                                                name="Date Of Birth"
                                                className={Style.dobInput}
                                                max={maxDOB.toISOString().split('T')[0]}
                                                min={minDOB.toISOString().split('T')[0]}
                                                value={UpdateProfile.dob}
                                                onChange={(e) => { handleDOBChange(e) }}
                                            />
                                            <p className={Style.error}>{Error.dob}</p>
                                        </div>
                                    </div>
                                    <div className={Style.row}>
                                        <div className={Style.col}>
                                            <label>House Name or Number / Flat Name or Number <span>*</span></label>
                                            <InputForm
                                                type="text"
                                                placeholder='House Name or Number / Flat Name or Number'
                                                id="houseName"
                                                name="houseName"
                                                value={UpdateProfile?.address?.houseName}
                                                onChange={(e) => {
                                                    SetUpdateProfile({ ...UpdateProfile, address: { ...UpdateProfile.address, houseName: e.target.value } })
                                                }}
                                            />
                                            <p className={Style.error}>{Error.houseName}</p>
                                        </div>
                                    </div>
                                    <div className={Style.row}>
                                        <div className={Style.col}>
                                            <label>Street Name <span>*</span></label>
                                            <InputForm
                                                type="text"
                                                placeholder='Street Name'
                                                id="StreetName"
                                                name="StreetName"
                                                value={UpdateProfile?.address?.streetName}
                                                onChange={(e) => {
                                                    SetUpdateProfile({ ...UpdateProfile, address: { ...UpdateProfile.address, streetName: e.target.value } })
                                                }}
                                            />
                                            <p className={Style.error}>{Error.streetName}</p>
                                        </div>
                                    </div>

                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>State <span>*</span></label>
                                            <Select
                                                options={StateOptions}
                                                placeholder={UpdateProfile?.address?.state || "Select State"}
                                                value={StateOptions.find(opt => opt.value === selectedStateName) || null}
                                                isSearchable={true}
                                                onChange={(e) => {
                                                    const stateName = e.value;
                                                    setSelectedStateName(stateName);
                                                    setSelectedDistrictName(""); // Reset district when state changes
                                                    SetUpdateProfile({ 
                                                        ...UpdateProfile, 
                                                        address: { 
                                                            ...UpdateProfile.address, 
                                                            state: stateName,
                                                            district: "" // Reset district in profile
                                                        } 
                                                    })
                                                }}
                                                styles={customStyles}
                                            />
                                            <p className={Style.error}>{Error.state}</p>
                                        </div>

                                        <div className={Style.col}>
                                            <label>District <span>*</span></label>
                                            <Select
                                                options={DistrictOptions}
                                                placeholder={UpdateProfile?.address?.district || "Select District"}
                                                value={DistrictOptions.find(opt => opt.value === selectedDistrictName) || null}
                                                onChange={(e) => {
                                                    const districtName = e.value;
                                                    setSelectedDistrictName(districtName);
                                                    SetUpdateProfile({ 
                                                        ...UpdateProfile, 
                                                        address: { 
                                                            ...UpdateProfile.address, 
                                                            district: districtName 
                                                        } 
                                                    })
                                                }}
                                                styles={customStyles}
                                                isDisabled={!selectedStateName}
                                            />
                                            <p className={Style.error}>{Error.district}</p>
                                        </div>
                                    </div>

                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>Region <span>*</span></label>
                                            <Select
                                                options={options}
                                                placeholder={UpdateProfile?.address?.region || "Select Region"}
                                                value={options.find(opt => opt.value === UpdateProfile?.address?.region) || null}
                                                onChange={(e) => {
                                                    SetUpdateProfile({ ...UpdateProfile, address: { ...UpdateProfile.address, region: e.value } })
                                                }}
                                                styles={customStyles}
                                            />
                                            <p className={Style.error}>{Error.region}</p>
                                        </div>
                                    </div>

                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>Email <span>*</span></label>
                                            <div className={Style.flex_col}>
                                                <InputForm
                                                    type="email"
                                                    placeholder='Email'
                                                    name="email"
                                                    value={UpdateProfile.email}
                                                    onChange={(e) => {
                                                        SetUpdateProfile({ ...UpdateProfile, email: e.target.value });
                                                        SetIsEmailEditing(true);
                                                        email_validation(e.target.value);
                                                    }}
                                                    customClass={Style.form_Input}
                                                />
                                                {IsEmailEditing && !IsEmailVerified && (
                                                    <div className={Style.form_button} onClick={handleVerifyEmail}>
                                                        <button type="button">Verify</button>
                                                    </div>
                                                )}
                                            </div>
                                            <p className={Style.error}>{Error.email}</p>
                                        </div>
                                    </div>
                                    <div className={Style.flex_row}>
                                        <div className={Style.col}>
                                            <label>Phone Number <span>*</span></label>
                                            <div className={Style.flex_col}>
                                                <InputForm
                                                    type="tel"
                                                    placeholder='Phone number'
                                                    name="phoneNumber"
                                                    value={UpdateProfile.phoneNumber}
                                                    onChange={(e) => {
                                                        SetUpdateProfile({ ...UpdateProfile, phoneNumber: e.target.value });
                                                        SetIsPhoneEditing(true);
                                                        phone_validation(e.target.value);
                                                    }}
                                                    customClass={Style.form_Input}
                                                />
                                                {IsPhoneEditing && !IsPhoneVerified && (
                                                    <div className={Style.form_button} onClick={handleVerifyPhoneNumber}>
                                                        <button type="button">Verify</button>
                                                    </div>
                                                )}
                                            </div>
                                            <p className={Style.error}>{Error.phoneNumber}</p>
                                        </div>
                                    </div>
                                    <div className={Style.button_row}>
                                        <div className={Style.cancelBtn} onClick={() => navigate(`/profile`)}>
                                            <button type="button">Cancel</button>
                                        </div>
                                        <div className={Style.submitBtn}>
                                            <button type="submit">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </div>
    )
}

export default UpdateProfileForm